import { SubappConfig } from './generateAppConfig';

const generateSubappConfig = (subappConfig: SubappConfig): SubappConfig =>
  subappConfig;

export default generateSubappConfig;
